import { motion } from "framer-motion";

const RANK = { 1: "A", 11: "J", 12: "Q", 13: "K" };
const SUIT = { S: ["♠", "#111"], H: ["♥", "#c4112f"], D: ["♦", "#c4112f"], C: ["♣", "#111"] };
const SIZE = { sm: "w-12 h-16", md: "w-20 h-28 sm:w-24 sm:h-36", lg: "w-36 h-52 sm:w-44 sm:h-64" };

export const CardBack = ({ size = "md" }) => (
  <div className={`${SIZE[size]} rounded-xl border-4 border-white/90 shadow-xl`} style={{ background: "repeating-linear-gradient(45deg,#c4112f 0 8px,#7B001C 8px 16px)" }} />
);

export const Card = ({ c, small, size, testid }) => {
  const sz = size || (small ? "sm" : "lg");
  const [s, col] = SUIT[c.suit];
  const r = RANK[c.rank] || c.rank;
  const big = sz === "lg";
  const tiny = sz === "sm";
  return (
    <div className={`relative bg-white rounded-xl shadow-[0_10px_30px_rgba(0,0,0,0.6)] border border-zinc-300 select-none shrink-0 ${SIZE[sz]}`} style={{ color: col }} data-testid={testid}>
      <div className={`absolute top-1.5 left-2 leading-none font-black ${tiny ? "text-sm" : big ? "text-2xl" : "text-lg"}`}>{r}<div>{s}</div></div>
      {!tiny && <div className={`absolute bottom-2 right-2 leading-none font-black rotate-180 ${big ? "text-2xl" : "text-lg"}`}>{r}<div>{s}</div></div>}
      <div className={`absolute inset-0 flex items-center justify-center ${tiny ? "text-xl" : big ? "text-7xl" : "text-4xl"}`}>{s}</div>
    </div>
  );
};

export const DealtCard = ({ c, i = 0, size = "md", testid }) => (
  <motion.div initial={{ y: -80, rotateY: 90, opacity: 0 }} animate={{ y: 0, rotateY: 0, opacity: 1 }} transition={{ delay: i * 0.15, duration: 0.35 }} style={{ transformPerspective: 800 }}>
    {c ? <Card c={c} size={size} testid={testid} /> : <CardBack size={size} />}
  </motion.div>
);

export const Hand = ({ cards, label, total, testid, hidden = 0 }) => (
  <div className="flex flex-col items-center gap-3" data-testid={testid}>
    <p className="text-xs uppercase tracking-[0.25em] text-white/70">{label}{total != null && <span className="ml-2 rounded-full bg-black/50 px-2.5 py-0.5 font-display font-bold text-[#FFD700]" data-testid={`${testid}-total`}>{total}</span>}</p>
    <div className="flex gap-2 min-h-[7rem] sm:min-h-[9rem]">
      {cards.map((c, i) => <DealtCard key={i} c={c} i={i} />)}
      {Array.from({ length: hidden }).map((_, i) => <DealtCard key={`h${i}`} c={null} i={cards.length + i} />)}
    </div>
  </div>
);
